import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";
import api from "@/lib/api";

export const DAY_NAMES = {
  ru: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
  kz: ["Дүйсенбі", "Сейсенбі", "Сәрсенбі", "Бейсенбі", "Жұма", "Сенбі", "Жексенбі"],
};

export const fmtHour = (h) => `${String(h).padStart(2, "0")}:00`;

export default function WorkingHours() {
  const { lang } = useLanguage();
  const [days, setDays] = useState(null);

  useEffect(() => {
    api.get("/schedule").then((r) => setDays(r.data.days)).catch(() => {});
  }, []);

  if (!days) return null;
  const names = DAY_NAMES[lang] || DAY_NAMES.ru;
  const closedLabel = lang === "kz" ? "Демалыс күні" : "Выходной";

  return (
    <div className="space-y-1" data-testid="working-hours">
      {days.map((d, i) => (
        <div key={d.dow} className="flex justify-between gap-6 text-sm" data-testid={`working-hours-day-${d.dow}`}>
          <span className="text-muted-foreground">{names[i]}</span>
          <span className={d.closed ? "text-destructive" : "text-foreground"}>
            {d.closed ? closedLabel : `${fmtHour(d.open_hour)} — ${fmtHour(d.close_hour)}`}
          </span>
        </div>
      ))}
    </div>
  );
}

export function WorkingHoursInline({ day }) {
  const { lang } = useLanguage();
  if (!day) return null;
  const closedLabel = lang === "kz" ? "Бұл күні жұмыс істемейміз" : "В этот день мы не работаем";
  return (
    <p className="text-sm flex items-center gap-2 mb-4" data-testid="working-hours-inline">
      <Clock className="w-4 h-4 text-primary" />
      {day.closed ? (
        <span className="text-destructive">{closedLabel}</span>
      ) : (
        <span className="text-muted-foreground">
          {lang === "kz" ? "Жұмыс уақыты" : "Часы работы"}: {fmtHour(day.open_hour)} — {fmtHour(day.close_hour)}
        </span>
      )}
    </p>
  );
}
